import * as BrowsersUtils from './Browsers';
import * as MapUtils from './Map';

export const Browsers = BrowsersUtils;
export const Map = MapUtils;
